export default {
    computed: {
        currentStepNumber() {
            return this.$route.meta.stepNumber;
        },
        checkoutSteps() {
            return this.steps[this.usePrepaidSteps ? 'prepaid' : 'general'];
        },
        currentStepTitle() {
            return this.checkoutSteps[this.currentStepNumber].title + this.$i18nApi.t(this.checkoutSteps[this.currentStepNumber].translationString);
        },
        sortedStepKeys() {
            const stepKeys = Object.keys(this.checkoutSteps);
            return this.sortSteps(stepKeys);
        },        
        pastSteps() {
            const sortedKeys = this.sortedStepKeys;
            const currentIndex = sortedKeys.indexOf(this.currentStepNumber);
            return sortedKeys.slice(0, currentIndex);
        },
        futureSteps() {
            const sortedKeys = this.sortedStepKeys;
            const currentIndex = sortedKeys.indexOf(this.currentStepNumber);
            return sortedKeys.slice(currentIndex + 1);
        },
    },
    methods: {
        sortSteps(keys) {
            return keys.sort((a, b) => {
                // Extract the numeric part of the step keys
                const numA = parseInt(a, 10);
                const numB = parseInt(b, 10);
        
                // If numeric parts are equal (e.g., '4' and '4a'), sort by full string value
                if (numA === numB) {
                    return a > b ? 1 : -1;
                }
        
                // Otherwise, sort by numeric value
                return numA - numB;
            });
        },

        isDirectlyPreviousStep(step) {
            const sortedKeys = this.sortedStepKeys;
            const currentIndex = sortedKeys.indexOf(this.currentStepNumber);
            const previousIndex = currentIndex - 1;
            return sortedKeys[previousIndex] === step;
        },
    },
};